const ListingsCountersTypes = {
  FETCH_LISTINGS_COUNTERS_REQUEST: 'FETCH_LISTINGS_COUNTERS_REQUEST',
  FETCH_LISTINGS_COUNTERS_SUCCESS: 'FETCH_LISTINGS_COUNTERS_SUCCESS',
  FETCH_LISTINGS_COUNTERS_ERROR: 'FETCH_LISTINGS_COUNTERS_ERROR',
};

export default ListingsCountersTypes;
